<div>
  <div class="flex justify-content-center">
    <input [(ngModel)]="aliasFilter"
           [focus]="true"
           appAutoFocus
           class="mt-1"
           pInputText
           placeholder="{{'search.byAlias' | transloco}}"
           style="width: 200px"
           type="search">
  </div>
  <div class="p-2 mt-3">
    <div *ngIf="filteredMachines?.length > 0" class="grid">
      <div *ngFor="let machine of filteredMachines" class="p-2 pb-0 col-12 md:col-6 lg:col-4 xl:col-2">
        <div (click)="onMachineSelected.emit(machine.machineUuid)" class="w-full machine-card flex">
          <div class="flex ml-2 mr-4" style="width: 50px">
            <img
              [src]="machine.model.image"
              [alt]="machine.model.modelName" class="align-self-center" height="70"
              width="auto">
          </div>
          <div class="flex flex-column mt-2" style="width: calc(100% - 50px);">
            <p class="pl-3 mb-0 bold white-space-nowrap overflow-hidden text-overflow-ellipsis w-12">
              {{machine.alias}}
            </p>
            <p class="pl-3 mb-0 white-space-nowrap overflow-hidden text-overflow-ellipsis w-12">
              {{machine.model.modelName}}
            </p>
            <p class="pl-3 mb-0 white-space-nowrap overflow-hidden text-overflow-ellipsis w-12">
              s/n: {{machine.serial}}
            </p>
            <div class="pl-3">
              <span class="mr-2">
                <p-tag *ngIf="machine.telemetryData?.isPoweredOn" value="{{'attribute.on' | transloco}}" class="green-tag cluster-tag"></p-tag>
                <p-tag *ngIf="!machine.telemetryData?.isPoweredOn" value="{{'attribute.off' | transloco}}" class="gray-tag cluster-tag"></p-tag>
              </span>
              <span>
                <p-tag *ngIf="machine.telemetryData?.hasAlarms" value="{{'attribute.hasAlarms' | transloco}}" class="red-tag cluster-tag"></p-tag>
                <p-tag *ngIf="!machine.telemetryData?.hasAlarms" value="{{'attribute.noAlarms' | transloco}}" class="green-tag cluster-tag"></p-tag>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="filteredMachines?.length == 0" class="text-center">
      <p>{{'misc.noMachinesFoundSearch' | transloco}}</p>
    </div>
  </div>
</div>
